import React from 'react';
import { LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import PitchTabTable from './PitchTabTable';

const Attack2kTab = ({ isLoading, pitchTypes, isLhp, isLoadingAvg }) => {
    const { t: translate } = useTranslation();

    if (isLoading) {
        return (
            <div className="py-5 text-center">
                <LoadingSpinner />
            </div>
        );
    }

    const filteredPitchTypes = pitchTypes.filter((pt) => pt.isattack || (pt.balls === -1 && pt.strikes === 2));

    return (
        <div>
            {filteredPitchTypes.length
                ? (
                    <>
                        <h4>{translate('sections.reports.pitcher.pitchcomparison.attackcounts')}</h4>
                        <PitchTabTable
                            pitchTypes={filteredPitchTypes.filter((pt) => pt.isattack)}
                            isLhp={isLhp}
                            isLoadingAvg={isLoadingAvg}
                        />
                        <h4 className="mt-4">{translate('sections.reports.pitcher.pitchcomparison.twokcounts')}</h4>
                        <PitchTabTable
                            pitchTypes={filteredPitchTypes.filter((pt) => pt.balls === -1 && pt.strikes === 2)}
                            isLhp={isLhp}
                            isLoadingAvg={isLoadingAvg}
                        />
                    </>
                )
                : <div className="py-5 text-center fs-6">{translate('pitcher-overview.no-data')}</div>}
        </div>
    );
};

export default Attack2kTab;
